import React from "react";
import {Tag, Tooltip, Typography} from "antd";
import {HealthCheckerGroupMember} from "../../../../../models/health-checker/health-checker";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {HealthCheckerNotificationMethodTag} from "./check-groups.notification-method";

const {Text} = Typography;
const VISIBLE_MEMBERS_COUNT = 3;

interface HealthCheckerGroupMembersProps {
    members: HealthCheckerGroupMember[];
}

const memberName = (member: HealthCheckerGroupMember): string =>
    `${member.user.firstName} ${member.user.lastName}`;

export const HealthCheckerGroupMembers: React.FC<HealthCheckerGroupMembersProps> = ({members}) => {
    const t = useTranslate();
    const visibleMembers = members.slice(0, VISIBLE_MEMBERS_COUNT);
    const hiddenMembersCount = members.length - visibleMembers.length;

    if (members.length === 0) {
        return <Text type="secondary">—</Text>;
    }

    const allMembers = members
        .map((member) => `${memberName(member)} (${member.notificationMethod})`)
        .join(", ");

    return (
        <div className="health-center-check-groups__members">
            {visibleMembers.map((member) => (
                <span className="health-center-check-groups__member" key={member.id}>
                    <Text>{memberName(member)}</Text>
                    <HealthCheckerNotificationMethodTag method={member.notificationMethod} />
                </span>
            ))}
            {hiddenMembersCount > 0 ? (
                <Tooltip title={allMembers}>
                    <Tag className="health-center-check-groups__more-members">
                        {t("HEALTH-CENTER.SETTINGS.CHECK-GROUPS.MORE-MEMBERS", {
                            count: hiddenMembersCount,
                            defaultValue: "+{{count}} more",
                        })}
                    </Tag>
                </Tooltip>
            ) : null}
        </div>
    );
};
